import { ComponentProps } from 'react';
import SelectControlled from './SelectControlled';

type SelectControlledWithLabelProps<T> = {
    annotated?: boolean;
    labelHidden?: boolean;
    tooltip?: string;
} & ComponentProps<typeof SelectControlled<T>>;

export default function SelectControlledWithLabel<T>({
    annotated = false,
    labelHidden,
    tooltip,
    label,
    name,
    ...props
}: SelectControlledWithLabelProps<T>) {
    const field = (
        <SelectControlled
            label={annotated ? undefined : label}
            labelAccessibilityVisibility={labelHidden ? 'exclusive' : undefined}
            name={name}
            {...props}
        />
    );

    if (!annotated) return field;

    return (
        <div className="grid grid-cols-2 items-center gap-2">
            <div className="flex flex-row items-center gap-2">
                <span>{label}</span>
                {!!tooltip && (
                    <>
                        <s-icon type="info" interestFor={`tooltip-${name}`}></s-icon>
                        <s-tooltip id={`tooltip-${name}`}>{tooltip}</s-tooltip>
                    </>
                )}
            </div>
            {field}
        </div>
    );
}
